import { Badge, Box } from "@mui/material";
import { BellRing, CheckSquare } from "lucide-react";
import { useFetchCaseTasksPending } from "@/queries/useFetchCaseTasksPending.ts";
import { useFetchNotificationsForUser } from "@/queries/useFetchNotificationsForUser.ts";

const TabBadges = () => {
    const { data: notificationData = [] } = useFetchNotificationsForUser();
    const { data: caseTasksData = [] } = useFetchCaseTasksPending();

    const unreadNotifications = notificationData.filter((n) => n.hasUnreadNotification);

    return (
        <Box>
            {unreadNotifications.length > 0 && (
                <Badge
                    badgeContent={unreadNotifications.length}
                    color="error"
                    sx={{
                        pl: 1,
                        "& .MuiBadge-badge": {
                            backgroundColor: "red",
                            color: "white",
                        },
                    }}
                >
                    <BellRing size={20} color="red" />
                </Badge>
            )}
            {caseTasksData.length > 0 && (
                <Badge
                    badgeContent={caseTasksData.length}
                    sx={{
                        pl: 1,
                        "& .MuiBadge-badge": {
                            backgroundColor: "green",
                            color: "white",
                        },
                    }}
                >
                    <CheckSquare size={20} color="green" />
                </Badge>
            )}
        </Box>
    );
};

export default TabBadges;
